import { createSelector } from '@ngrx/store'
import { tableLightColors, shareOSSDotMenuIds } from 'src/app/helpers/table-helpers'
import { capitalize } from '../../helpers/helpers'
import { eventStateSelector, ShareOSSInfo } from '../events.era'
import { LogisticsShareTableData, ShareTableData } from 'src/app/helpers/table-column-types'
import { shareStateSelector } from '../share.era'
import { filterStateSelector } from '../filters.era'
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers'

const shareInfo = createSelector(shareStateSelector, (state) => state.oss);
const logisticsShareables = createSelector(shareStateSelector, (state) => state.logistics);
const eventTitle = createSelector(eventStateSelector, (state) => state.event ? state.event.title : 'Unknown Title');
const shareSearchTerm = createSelector(filterStateSelector, (state) => state.onsiteShare.search);
const logisticsSearchTerm = createSelector(filterStateSelector, (state) => state.programLogistics.search);

export const shareInfoReselector = createSelector(
  shareInfo,
  (shareInfo: {[key:string]: ShareOSSInfo }, shareId) => {
    // console.log({ shareInfo, eventTitle, publishCode })
    if (!shareInfo || !shareId) return null
    return shareInfo[shareId]
  }
)

export const logisticsShareReselector = createSelector(
  logisticsShareables,
  logisticsSearchTerm,
  (shareInfo, searchTerm) => {

    searchTerm = searchTerm ? searchTerm.toLocaleUpperCase() : null
    const shareIds = Object.keys(shareInfo)

    const shareTableData: LogisticsShareTableData[] = shareIds.filter(code => {
      const { title, description } = shareInfo[code]
      return !searchTerm || title.toLocaleUpperCase().includes(searchTerm) ||
            (description && description.toLocaleUpperCase().includes(searchTerm))
    }).map(code => {
      const { status, title, description } = shareInfo[code]
      const activeDotMenuOptions = new Set(shareOSSDotMenuIds)
      const publishTableRow: LogisticsShareTableData = {
        id: code,
        name: { text: title || 'Unnamed Production View'},
        description: { text: description || '' },
        status: {
          percent: status === 'shared' ? 1 : status === 'unshared' ? 0 : -1,
          lights: [{
            text: capitalize(status),
            color: status === 'shared' ? tableLightColors.green  : status === 'unshared' ? tableLightColors.red  : tableLightColors.gray,
          }]},
        shareInfo: shareInfo[code],
        activeDotMenuOptions
      }
      return publishTableRow
    })
    const shareTableRowsById = makeMapFromListOfObjectsAndKey(shareTableData, 'id')
    return { shareTableData, shareTableRowsById }
  }
)


export const shareOSSReselector = createSelector(
  shareInfo,
  eventTitle,
  shareSearchTerm,
  (shareInfo, eventTitle, searchTerm) => {

    searchTerm = searchTerm ? searchTerm.toLocaleUpperCase() : null
    const shareIds = Object.keys(shareInfo)

    const shareTableData: ShareTableData[] = shareIds.filter(code => {
      const { title, description } = shareInfo[code]
      return !searchTerm || title.toLocaleUpperCase().includes(searchTerm) ||
            (description && description.toLocaleUpperCase().includes(searchTerm))
    }).map(code => {
      const { status, title, description } = shareInfo[code]
      const activeDotMenuOptions = new Set(shareOSSDotMenuIds)
      const publishTableRow: ShareTableData = {
        id: code,
        name: { text: title || eventTitle},
        description: { text: description || '' },
        status: {
          percent: status === 'shared' ? 1 : status === 'unshared' ? 0 : -1,
          lights: [{
            text: capitalize(status),
            color: status === 'shared' ? tableLightColors.green  : status === 'unshared' ? tableLightColors.red  : tableLightColors.gray,
          }]},
        shareInfo: shareInfo[code],
        activeDotMenuOptions
      }
      return publishTableRow
    })
    const shareTableRowsById = makeMapFromListOfObjectsAndKey(shareTableData, 'id')
    return { shareTableData, shareTableRowsById }
  }
)
